import React, { Component, Fragment } from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import { Layout } from 'antd';

export default class CountrySelectContainer extends Component {

    render() {
        const { Content } = Layout;
        return (
            <Fragment>
                <Header/>
                <Content className="main-content">
                   {this.props.children}
                </Content>
                <Footer/>   
            </Fragment>
        )
    }
}
